import axios from 'axios'

const state = {
  questions: [{}],
  sections: [],
  indexSectionDragHistory: null,
  indexQuestionDragHistory: null,
  isLoading_adminQuestions: true,
  isLoading_public: true,
  isSaving: false,
  isSaved: false,
  displayToast: false,
  AllFolding: [],
  foldingQuestion: [],
  idSection: 0,
  languages: null,
  type_formulaire: 'simple',
  section: {},
  initial_section: {
    id: 0,
    onglet: 'Section ',
    entitled: 'Section sans titre',
    order: '999'
  },
  showTreeComponent: false,
  question: {},
  initial_question: {
    entitled: null,
    entitled_en: null,
    entitled_es: null,
    entitled_de: null,
    file_url: null,
    element_type: 'radio',
    current_section: null,
    relation_section: false,
    autre: '0',
    optional: '0',
    order: '999'
  },
  answer: {},
  initial_answer: {
    entitled: null,
    entitled_en: null,
    entitled_es: null,
    entitled_de: null,
    conditional_section: null,
    proposition_type: 'radio',
    file_url: null,
    order: '999'
  },
  arrayLanguagesUpdated: ['fr'],
  testSaveQuestionButton: false,
  testSaveAnswersButton: false,
  testSaveSectionsButton: false
}

class Section {
  constructor (section) {
    (this.id = section.id),
    (this.onglet = section.onglet),
    (this.entitled = section.entitled),
    (this.order = section.order)
    this.questions = [new Question(state.initial_question)]
  }
}
class Question {
  constructor (question) {
    (this.entitled = question.entitled),
    (this.entitled_en = question.entitled_en),
    (this.entitled_es = question.entitled_es),
    (this.entitled_de = question.entitled_de),
    (this.file_url = question.file_url),
    (this.element_type = question.element_type),
    (this.current_section = question.current_section),
    (this.relation_section = question.relation_section),
    (this.autre = question.autre),
    (this.optional = question.optional),
    (this.order = question.order),
    (this.answers = [
      new Proposition(state.answer),
      new Proposition(state.answer)
    ])
  }
}

class Proposition {
  constructor (answer) {
    (this.entitled = answer.entitled),
    (this.entitled_en = answer.entitled_en),
    (this.entitled_es = answer.entitled_es),
    (this.entitled_de = answer.entitled_de),
    (this.current_section = answer.current_section),
    (this.conditional_section = answer.conditional_section),
    (this.next_section = answer.next_section),
    (this.proposition_type = answer.proposition_type),
    (this.file_url = answer.file_url),
    (this.order = answer.order)
  }
}

const mutations = {

  TEST_SAVE_QUESTION_BUTTON (state, payload) {
    state.testSaveQuestionButton = !state.testSaveQuestionButton
  },
  TEST_SAVE_ANSWERS_BUTTON (state, payload) {
    state.testSaveAnswersButton = !state.testSaveAnswersButton
  },
  TEST_SAVE_SECTIONS_BUTTON (state, payload) {
    state.testSaveSectionsButton = !state.testSaveSectionsButton
  },
  UPDATE_ELEMENT_TYPE_QUESTION (state, payload) {
    switch (payload.type) {
      case 'section':
        state.sections[payload.indexSection].questions[payload.indexQuestion] =
          payload.question
        break
      case 'simple':
        state.questions[payload.indexQuestion] = payload.question
        break
    }
  },
  UPDATE_QUESTION (state, payload) {
    state.questions[payload.indexQuestion] = payload.question
  },
  INDEX_SECTION_DRAG_HISTORY (state, payload) {
    state.indexSectionDragHistory = payload.indexSection
    state.indexQuestionDragHistory = payload.indexQuestion
  },
  RESET_CHANGE_ORDER_QUESTION (state, payload) {
    state.sections.forEach((section, indexSection) => {
      section.questions.forEach((question, indexQuestion) => {
        if (question.order === payload.question.order) {
          state.sections[indexSection].questions.splice(indexQuestion, 1)
        }
      })
    })
    state.sections[state.indexSectionDragHistory].questions.splice(
      state.indexQuestionDragHistory,
      0,
      payload.question
    )
    state.sections.forEach((section, index) => {
      section.order = index
    })
  },
  RESET_QUESTION_CHANGE_TYPE_OPTIONS_SECTIONS (state, payload) {
    state.sections[payload.indexSection].questions[
      payload.indexQuestion
    ].relation_section = 0
    state.sections[payload.indexSection].questions[
      payload.indexQuestion
    ].answers.forEach(answer => {
      answer.next_section = 0
      answer.conditional_section = null
    })
  },
  VALIDATE_CHANGE (state, payload) {
    let sectionsWithOrder = payload.forEach((section, index) => {
      section.order = index
    })
    state.sections.push(sectionsWithOrder)
    state.sections.pop()
  },
  RESET_CHANGE_ORDER_SECTION (state, payload) {
    state.sections.forEach((section, indexSection) => {
      if (section.order === payload.section.order) {
        state.sections.splice(indexSection, 1)
      }
    })
    state.sections.splice(state.indexSectionDragHistory, 0, payload.section)
    state.sections.forEach((section, index) => {
      section.order = index
    })
  },
  UPDATE_DISPLAY_TOAST (state, payload) {
    state.displayToast = !state.displayToast
    setTimeout(() => {
      state.displayToast = !state.displayToast
    }, 2000)
  },
  UPDATE_SAVED_TOAST (state, payload) {
    state.isSaved = payload
  },
  UPDATE_PROPOSITION_ORDER (state, payload) {
    payload.question.answers = payload.newValue
  },
  UPDATE_QUESTIONS_OR_SECTIONS_ORDER (state, payload) {
    switch (payload.type) {
      case 'simple':
        state.questions = payload.response
        break
      case 'section':
        state.sections = payload.response.forEach((section, index) => {
          section.order = index
        })
        break
    }
  },
  LOAD_QUESTIONS (state, payload) {
    state.sections = []
    state.questions = []
    if (payload[0].questions) {
      state.sections = payload
    } else {
      state.questions = payload
    }
  },
  IS_LOADING_QUESTION_ADMIN (state, payload) {
    state.isLoading_adminQuestions = true
  },
  IS_NOT_LOADING_QUESTION_ADMIN (state, payload) {
    state.isLoading_adminQuestions = false
  },
  IS_LOADING_PUBLIC (state, payload) {
    state.isLoading_public = payload
  },
  IS_SAVING (state, payload) {
    state.isSaving = true
  },
  IS_NOT_SAVING (state, payload) {
    state.isSaving = false
  },
  REMOVE_QUESTION (state, payload) {
    if (payload.type === 'section') {
      state.sections[payload.indexSection].questions.splice(
        payload.indexQuestion,
        1
      )
    } else {
      state.questions.splice(payload.indexQuestion, 1)
    }
  },
  ADD_QUESTION (state, payload) {
    if (payload >= 0) {
      state.sections[payload].questions.push(
        new Question(state.initial_question)
      )
      state.questions.forEach((question, index) => {
        question.order = index
      })
    } else {
      state.questions.push(new Question(state.initial_question))
    }
  },
  RESET_ALL_OPTIONS_DRAG (state, payload) {
    switch (payload.type) {
      case 'section':
        payload.data.questions.forEach((question, indexQuestion) => {
          question.answers.forEach(answer => {
            if (payload.data.order <= answer.conditional_section) {
              // on reinitialise
              payload.data.questions.forEach(question => {
                question.optional = 0
                question.autre = 0
                question.relation_section = 0
                question.answers.forEach(answer => {
                  answer.next_section = 0
                  answer.conditional_section = null
                })
              })
            }
          })
        })
        break
      case 'question':
        payload.data.optional = 0
        payload.data.autre = 0
        payload.data.relation_section = 0
        payload.data.answers.forEach(answer => {
          answer.next_section = 0
          answer.conditional_section = null
        })
        break
    }
  },
  UDPATE_SECTIONS_OPTIONS (state, payload) {
    // init
    let answer =
      state.sections[payload.indexSection].questions[payload.indexQuestion]
        .answers[payload.indexAnswer]
    state.question =
      state.sections[payload.indexSection].questions[payload.indexQuestion]

    switch (payload.type) {
      /** @use utilisé dans dropdownBurgerQuestion */
      case 'update_question_relation_section':
        state.question.relation_section = payload.relation_section
        if (
          payload.relation_section === false ||
          payload.relation_section === 0
        ) {
          state.question.optional = 0
          state.question.autre = '0'
          state.question.answers.forEach(function (answer) {
            answer.next_section = 1
            answer.conditional_section = null
          })
          state.sections[payload.indexSection].questions.splice(
            payload.indexQuestion,
            1,
            state.question
          )
        }
        break
      /** @use utilisé dans dropdownSectionListAnswer  */
      case 'update_answers_conditional_section_next_section':
        if (payload.conditional_section !== null) {
          answer.conditional_section = payload.conditional_section
          answer.next_section = 0
          state.question.relation_section = 1
          state.sections[payload.indexSection].questions.splice(
            payload.indexQuestion,
            1,
            state.question
          )
        } else {
          answer.conditional_section = null
          answer.next_section = 1
          state.question.relation_section = 1
          state.sections[payload.indexSection].questions.splice(
            payload.indexQuestion,
            1,
            state.question
          )
        }
        break
      /** @use utilisé dans blocGabaritQuestion  */
      case 'reset_answers_next_section_conditional_section':
        let passage = false
        if (passage === false) {
          state.question.relation_section = false
          state.question.answers.map(function (x) {
            x.conditional_section = null
            x.next_section = 1
          })
        }
        passage = true
        break
    }
  },
  ADD_SECTION (state, payload) {
    if (state.sections.length && state.questions.length) {
      state.sections.push(new Section(state.initial_section))
      state.sections[state.sections.length - 1].id =
        state.sections[state.sections.length - 2].id + 1
      state.sections[state.sections.length - 1].order =
        state.sections[state.sections.length - 2].order + 1
    } else if (!state.sections.length && state.questions.length) {
      state.sections.push(new Section(state.initial_section))
      state.sections[0].questions = state.questions
      state.sections[0].entitled = payload.entitledSurvey
      state.sections[state.sections.length - 1].id = 0
      state.sections[state.sections.length - 1].order = 0
      state.sections.push(new Section(state.initial_section))
      state.sections[state.sections.length - 1].id = 1
      state.sections[state.sections.length - 1].order = 1
    } else {
      state.idSection = state.sections[state.sections.length - 1].order + 1
      state.sections.push(new Section(state.initial_section))
      state.sections[state.sections.length - 1].id = state.idSection
      state.sections[state.sections.length - 1].order = state.idSection
    }
  },
  UDAPTE_SECTION_ENTITLED (state, payload) {
    state.sections[payload.indexSection].entitled = payload.updateEntitled
    state.sections.splice(
      payload.indexSection,
      1,
      state.sections[payload.indexSection]
    )
  },
  REMOVE_SECTION (state, indexSection) {
    if (state.sections.length === 1) {
      state.questions = state.sections[0].questions
      state.idSection = 0
      state.sections = []
    } else {
      state.sections.splice(indexSection, 1)
      let lastIdSection = state.sections.length - 1
      state.sections[lastIdSection].questions.map(question => {
        question.relation_section = false
        question.autre = '0'
        question.answers.map(answer => {
          answer.next_section = 0
        })
      })
    }
    // en depannage en atedant les ids de la BDD
    state.idSection -= 1
    // if we delete the section, we upload the function in SaveQuestionButton component
    state.testSaveSectionsButton = !state.testSaveSectionsButton
  },
  DUPLICATE_QUESTION (state, payload) {
    if (payload.type === 'section') {
      state.question =
        state.sections[payload.indexSection].questions[payload.indexQuestion]
      state.sections[payload.indexSection].questions.splice(
        payload.indexQuestion + 1,
        0,
        new Question(state.question)
      )
      state.sections[payload.indexSection].questions[
        payload.indexQuestion
      ].answers.forEach(function (item, index) {
        state.answer =
          state.sections[payload.indexSection].questions[
            payload.indexQuestion
          ].answers[index]
        state.sections[payload.indexSection].questions[
          payload.indexQuestion + 1
        ].answers[index] = new Proposition(state.answer)
      })
    } else {
      state.question = state.questions[payload.indexQuestion]
      state.questions.splice(
        payload.indexQuestion + 1,
        0,
        new Question(state.question)
      )
      state.questions[payload.indexQuestion].answers.forEach(function (
        item,
        index
      ) {
        state.answer = state.questions[payload.indexQuestion].answers[index]
        state.questions[payload.indexQuestion + 1].answers[
          index
        ] = new Proposition(state.answer)
      })
    }
  },
  ADD_IMG_ANSWER (state, payload) {
    let answer = payload.answer
    answer.file_url = payload.dataUri
    if (payload.indexSection !== undefined) {
      state.sections[payload.indexSection].questions[payload.indexQuestion].answers.splice(payload.indexAnswer, 1, answer)
    } else {
      state.questions[payload.indexQuestion].answers.splice(payload.indexAnswer, 1, answer)
    }
  },
  DELETE_IMG_ANSWER (state, payload) {
    let answer = payload.answer
    answer.file_url = null
    if (payload.indexSection !== undefined) {
      state.sections[payload.indexSection].questions[payload.indexQuestion].answers.splice(payload.indexAnswer, 1, answer)
    } else {
      state.questions[payload.indexQuestion].answers.splice(payload.indexAnswer, 1, answer)
    }
  },
  ADD_PROPOSITION (state, payload) {
    payload.answers.push(new Proposition(state.initial_answer))
  },
  UPDATE_PROPOSITION_ASSOCIATE_SECTION (state, payload) {
    state.sections[payload.indexSection].questions[
      payload.indexQuestion
    ].answers[payload.indexAnswer].conditional_section = payload.response
    state.sections[payload.indexSection].questions[
      payload.indexQuestion
    ].answers[payload.indexAnswer].next_section = payload.next_section
  },
  REMOVE_PROPOSITION (state, payload) {
    payload.question.answers.splice(payload.indexProposition, 1)
  },
  UPDATE_ALL_FOLDING (state, payload) {
    if (payload.data.length) {
      switch (payload.type) {
        case 'sections':
          payload.data.forEach((section, indexSection) => {
            state.AllFolding.push({
              indexSection: indexSection,
              questions: []
            })
            section.questions.forEach((question, indexQuestion) => {
              state.AllFolding[indexSection].questions.push(indexQuestion)
            })
          })
          break
        case 'questions':
          payload.data.forEach((question, indexQuestion) => {
            state.AllFolding.push(indexQuestion)
          })
          break
      }
    } else {
      state.AllFolding = []
    }
  },
  FOLDING_QUESTION (state, payload) {
    switch (payload.type) {
      case 'add':
        if (payload.indexSection !== undefined) {
          if (state.AllFolding[payload.indexSection] === undefined) {
            for (var z = 0; z < payload.indexSection + 1; z++) {
              if (state.AllFolding[z] === undefined) {
                state.AllFolding.push({
                  indexSection: z,
                  questions: []
                })
              }
            }
            state.AllFolding[payload.indexSection].questions.push(payload.indexQuestion)
          } else { state.AllFolding[payload.indexSection].questions.push(payload.indexQuestion) }
        } else {
          state.AllFolding.push(payload.indexQuestion)
        }
        break
      case 'remove':
        if (payload.indexSection !== undefined) {
          for (var i = 0; i < state.AllFolding[payload.indexSection].questions.length; i++) {
            if (state.AllFolding[payload.indexSection].questions[i] === payload.indexQuestion) {
              state.AllFolding[payload.indexSection].questions.splice(i, 1)
            }
          }
        } else {
          for (var j = 0; j < state.AllFolding.length; j++) {
            if (state.AllFolding[j] === payload.indexQuestion) {
              state.AllFolding.splice(j, 1)
            }
          }
        }
        break
    }
  },
  UPDATE_TYPE_FORM (state, payload) {
    state.type_formulaire = payload
  },
  UPDATE_LANGUAGES (state, payload) {
    state.languages = payload
  },
  UPDATE_ARRAY_LANGUAGES (state, payload) {
    state.arrayLanguagesUpdated = payload
  },
  SHOW_TREE_COMPONENT (state, payload) {
    state.showTreeComponent = payload
  }
}

const actions = {
  getTranslation ({ commit }, params) {
    let stringApiDeepl =
      `&text=` +
      params.stringToTranslate +
      `&target_lang=` +
      params.languageToTranslate +
      (params.languageOrigin !== undefined
        ? `&source_lang=` + params.languageOrigin
        : '')
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + window.store.getters.userToken
    axios
      .post(
        process.env.URL_SSO_API +
          'sondage/sondage/' +
          window.store.getters.configure_questions_sondage +
          '/translation',
        { stringApiDeepl: stringApiDeepl }
      )
      .then(response => {
        // translations QUESTION in SECTION //
        if (params.indexSection !== undefined) {
          if (params.languageToTranslate === 'fr') {
            let questions = params.sections[params.indexSection].questions
            questions[params.indexQuestion].entitled =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled = response.data.translations[index].text
            })
            state.sections = params.sections[
              params.indexSection
            ].questions.splice(0, questions)
          } else if (params.languageToTranslate === 'en') {
            let questions = params.sections[params.indexSection].questions
            questions[params.indexQuestion].entitled_en =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_en = response.data.translations[index].text
            })
            state.sections = params.sections[
              params.indexSection
            ].questions.splice(0, questions)
          } else if (params.languageToTranslate === 'es') {
            let questions = params.sections[params.indexSection].questions
            questions[params.indexQuestion].entitled_es =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_es = response.data.translations[index].text
            })
            state.sections = params.sections[
              params.indexSection
            ].questions.splice(0, questions)
          } else if (params.languageToTranslate === 'de') {
            let questions = params.sections[params.indexSection].questions
            questions[params.indexQuestion].entitled_de =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_de = response.data.translations[index].text
            })
            state.sections = params.sections[
              params.indexSection
            ].questions.splice(0, questions)
          }
        } // translations QUESTION //
        else {
          if (params.languageToTranslate === 'fr') {
            let questions = params.questions
            questions[params.indexQuestion].entitled =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled = response.data.translations[index].text
            })
            state.questions = state.questions.splice(0, questions)
          } else if (params.languageToTranslate === 'en') {
            let questions = params.questions
            questions[params.indexQuestion].entitled_en =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_en = response.data.translations[index].text
            })
            state.questions = state.questions.splice(0, questions)
          } else if (params.languageToTranslate === 'es') {
            let questions = params.questions
            questions[params.indexQuestion].entitled_es =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_es = response.data.translations[index].text
            })
            state.questions = state.questions.splice(0, questions)
          } else if (params.languageToTranslate === 'de') {
            let questions = params.questions
            questions[params.indexQuestion].entitled_de =
              response.data.translations[0].text
            let answers = response.data.translations
            answers.shift()
            questions[params.indexQuestion].answers.forEach((answer, index) => {
              answer.entitled_de = response.data.translations[index].text
            })
            state.questions = state.questions.splice(0, questions)
          }
        }
        commit('TEST_SAVE_QUESTION_BUTTON')
      })
  },
  getQuestionsAdmin ({ commit }) {
    commit('IS_LOADING_QUESTION_ADMIN')
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + window.store.getters.userToken
    axios
      .get(
        process.env.URL_SSO_API +
          'sondage/sondage/' +
          window.store.getters.configure_questions_sondage +
          '/elementwithanswers'
      )
      .then(response => {
        if (response.data.length) {
          commit('UPDATE_TYPE_FORM', 'simple')
          commit('LOAD_QUESTIONS', response.data)
          // permet d'ajouter une langue aux questions du sondage'
          if (response.data[0].onglet === 'Section') {
            commit('UPDATE_TYPE_FORM', 'section')
          }
        } else {
          commit('LOAD_QUESTIONS', [new Question(state.initial_question)])
        }
        commit('IS_NOT_LOADING_QUESTION_ADMIN')
      })
  },
  getQuestionsPublic ({ commit }, params) {
    commit('IS_LOADING_PUBLIC', true)
    axios.defaults.headers.common['urlparticipant'] = params['urlparticipant']
    axios
      .get(
        process.env.URL_SSO_API +
          'sondage/public/sondage/' +
          params['idSondage'] +
          '/elementwithanswers'
      )
      .then(response => {
        if (response.data.length) {
          if (response.data[0].onglet === 'Section') {
            commit('UPDATE_TYPE_FORM', 'section')
            commit('LOAD_QUESTIONS', response.data)
          } else {
            commit('UPDATE_TYPE_FORM', 'simple')
            commit('LOAD_QUESTIONS', response.data)
          }
          commit('IS_LOADING_PUBLIC', false)
        } else {
          if (window.location !== window.parent.location) {
            let message = {
              task: 'finSondage'
            }
            window.top.postMessage(message, '*')
          } else {
            window.location = process.env.URL_SONDAGES
          }
        }
      })
  },
  saveQuestions ({ commit }) {
    this.commit('IS_SAVING')
    axios.defaults.headers.common['Authorization'] =
      'Bearer ' + window.store.getters.userToken
    let formulaire
    if (this.getters.sections.length) {
      formulaire = this.getters.sections
    } else {
      formulaire = this.getters.questions
    }
    axios
      .put(
        process.env.URL_SSO_API +
          'sondage/sondage/' +
          window.store.getters.configure_questions_sondage +
          '/recreate',
        formulaire
      )
      .then(response => {
        commit('LOAD_QUESTIONS', response.data)
        this.commit('IS_NOT_SAVING')
        this.commit('UPDATE_SAVED_TOAST', true)
        this.commit('UPDATE_DISPLAY_TOAST')
      })
      .catch(error => {
        this.commit('IS_NOT_SAVING')
        this.commit('UPDATE_SAVED_TOAST', false)
        this.commit('UPDATE_DISPLAY_TOAST')
      })
  }
}

const getters = {
  question: state => state.question,
  questions: state => state.questions,
  sections: state => state.sections,
  AllFolding: state => state.AllFolding,
  foldingQuestion: state => state.foldingQuestion,
  type_formulaire: state => state.type_formulaire,
  isLoading_public: state => state.isLoading_public,
  isLoading_adminQuestions: state => state.isLoading_adminQuestions,
  languages: state => state.languages,
  arrayLanguagesUpdated: state => state.arrayLanguagesUpdated,
  showTreeComponent: state => state.showTreeComponent,
  testSaveQuestionButton: state => state.testSaveQuestionButton,
  testSaveAnswersButton: state => state.testSaveAnswersButton,
  testSaveSectionsButton: state => state.testSaveSectionsButton
}

const questionModule = {
  state,
  mutations,
  actions,
  getters
}

export default questionModule



// WEBPACK FOOTER //
// ./src/store/modules/question/index.js